export enum SortEquipmentRequestColumnsEnum {
    RequestName = 'request.name',
    SportObjectName = 'sportObject.name',
    RequestCount = 'request.count',
    RequestCreatedAt = 'request.createdAt',
    RequestSportKind = 'sportKind.name',
    RequestRequestStatus = 'request.requestStatus',
    RequestRejectReason = 'request.rejectReason',
    RequestDescription = 'request.description',
    RequestPrice = 'request.price'
}

